import type { IAssetSource } from '@monofe/util';
import type { CSSProperties, ReactNode } from 'react';

export enum ImageLoadingStrategy {
    Undef = 0,
    Lazy = 1,
    Eager = 2,
}

export interface IImageProperties {
    urls: Readonly<IAssetSource>[] /* List of src files. Should be ordered in priority to display */;
    mode?: 'contain' | 'cover';
    description?: string /* Alt text of image (screen reader */;
    style?: CSSProperties;
    className?: string;
    loading?: ImageLoadingStrategy /* Default to Lazy */;
    children?: ReactNode;
    onLoaded?: () => void;
}

/* Expose original interface until refactor complete */
/* eslint-disable-next-line @typescript-eslint/no-empty-interface, unicorn/prevent-abbreviations */
export interface IImageProps extends IImageProperties {}
